<template>
  <div class="display-element" v-html="htmlValue"></div>
</template>

<script>
import showdown from 'showdown';

export default {
  props: {
    value: { type: [String, Number], default: '' },
  },
  setup(props) {
    const converter = new showdown.Converter();

    const htmlValue = converter.makeHtml(props.value);

    return {
      htmlValue,
    }
  },
};
</script>
